{
  "actions": "Azioni",
  "hideButtonLabel": "Mostra meno",
  "showAllButtonLabel": "Mostra tutto ({tagCount, number})"
}
